/* eslint-disable import/prefer-default-export */
const TERRITORIES_TYPES = {
    COUNTRY: 'COUNTRY',
    DISTRICT: 'DISTRICT',
    COUNTY: 'COUNTY',
    PARISH: 'PARISH'
};

export { TERRITORIES_TYPES };
